export default __webpack_public_path__ + "static/1389-0e7502df209b5f893063fba6f30729c4.gif";